import * as p from '@clack/prompts'

export interface ProjectPromptResult {
  projectName: string
}

/**
 * Prompt for the project name (fresh project only).
 */
export async function promptProject(defaultName?: string): Promise<ProjectPromptResult> {
  const projectName = await p.text({
    message: 'Enter the project name',
    placeholder: defaultName ?? '(Leave blank to skip directory creation)',
    defaultValue: defaultName ?? '.',
    validate: (value) => {
      if (!value?.trim()) return undefined
      if (value.trim() === '.') return undefined
      if (!/^[a-z0-9_-]+$/i.test(value.trim())) {
        return 'Project name can only contain letters, numbers, hyphens, and underscores'
      }
      return undefined
    }
  })

  if (p.isCancel(projectName)) {
    p.cancel('Setup cancelled.')
    process.exit(0)
  }

  return { projectName: projectName.trim() || '.' }
}
